<template>
    <div class="quizQuestions">

        <h1 v-html="question"></h1>
        <div class="answer"
             :class="getAnswerClass(index)"
             v-on:click="select(index), getLink()" :key="index" v-for="(answer, index) in answers">
            <div class="circle">
                <div class="circle-small">
                </div>
            </div>
            <p v-html="answer"></p>
        </div>
        <div class="actions">

            <button-next v-if="checking" v-bind:link="link" v-on:click.native="buttonClick()">
            </button-next>

        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import ButtonNext from '@/components/shared/ButtonNext';

    export default {
        data: function () {
            return {
                questions: [],
                questionIndex: 0,
                selected: null,
                checking: false,
                link: {},
                question: "",
                answers: [],
                correct: "",
            }
        },
        components: {
            'button-next': ButtonNext
        },
        methods: {

            init: function () {
                this.getQuestions();
                this.setQuestionIndex();
            },

            resetData: function () {
                this.questions = [];
                this.questionIndex = 0;
                this.selected = null;
                this.checking = false;
                this.link = {};
                this.question = "";
                this.answers = [];
                this.correct = "";
            },

            getQuestions: function () {
                if (localStorage.getItem(Vue.localStorageName)) {
                    this.questions = JSON.parse(localStorage.getItem(Vue.localStorageName));
                }
            },

            setQuestionIndex: function () {
                var i = 0;

                while (i < Vue.questionMaxCount && this.questions[i].answered !== "") {
                    i++;
                }

                if (i < Vue.questionMaxCount) {
                    this.questionIndex = i;
                    this.setData();
                }else{
                    this.questionIndex = Vue.questionMaxCount;
                    this.$router.push({ name: 'endScreen' });
                } 
            },

            setData: function () {
                this.question = this.questions[this.questionIndex].question;
                this.answers = this.questions[this.questionIndex].answers;
                this.correct = this.questions[this.questionIndex].correct;
            },

            select: function (index) {
                if (!this.checking) {
                    this.selected = index;
                    this.questions[this.questionIndex].answered = index;
                    this.saveQuestions();
                }
            },

            saveQuestions: function () {
                const parsed = JSON.stringify(this.questions);
                localStorage.setItem(Vue.localStorageName, parsed);
            },

            getLink: function () {
                if (this.selected !== null) {
                    this.checking = true;

                    if (this.questionIndex < Vue.questionMaxCount - 1) {
                        this.link = {name: 'quizScreen'}
                    } else {
                        this.link = {name: 'endScreen'}
                    }
                }
            },

            buttonClick: function () {
                this.resetData();

                if (this.questionIndex < Vue.questionMaxCount - 1) {
                    this.init();
                    this.link = {name: 'quizScreen'}
                } else {
                    this.link = {name: 'endScreen'}
                }
            },
            getAnswerClass: function(answerIndex){
                var answerClass = "";
                
                if( this.checking && (parseInt(this.correct) === answerIndex)){
                    answerClass = "correct";
                }else if( this.checking && (parseInt(this.correct) !== answerIndex) && answerIndex === this.selected){
                    answerClass = "notCorrect";
                }
                return answerClass;
            }
        },
        mounted() {
            this.init();
        }
    }
</script>

<style lang="scss">
    .quizQuestions {
        width: 460px;
        margin: auto;

        h1 {
            font-size: 24px;
            line-height: 34px;
            font-weight: 500;
            text-align: left;
        }

        .answer {
            box-sizing: border-box;
            display: flex;
            cursor: pointer;
            text-align: left;

            p {
                float: left;
                font-size: 24px;
                font-weight: bold;
                line-height: 34px;
                padding-left: 8px;
                margin: 15px 0px;
            }

            .circle {
                float: left;
                width: 27px;
                height: 27px;
                border: solid 2px #ffffff;
                border-radius: 4px;
                box-sizing: border-box;
                align-self: center;

            }

            &.correct {

                p {
                    color: #00aa00;
                    font-size: 35px;
                }

                .circle {
                    border-color: white;
                    display: flex;
                    justify-content: center;

                    .circle-small {
                        position: relative;
                        width: 27px;
                        height: 27px;
                        border-radius: 50%;
                        align-self: center;

                        &:before {
                            content: "";
                            width: 27px;
                            height: 27px;
                            position: absolute;
                            top: 2px;
                            left: 3px;
                            background-image: url('~@/assets/images/pipe.png');
                            background-repeat: no-repeat;
                        }
                    }
                }
            }

            &.notCorrect {
                p {
                    color: #c9302d;
                }

                .circle {
                    display: flex;
                    justify-content: center;

                    .circle-small {
                        position: relative;
                        width: 27px;
                        height: 27px;
                        border-radius: 50%;
                        align-self: center;

                        &:before {
                            content: "";
                            width: 5px;
                            height: 26px;
                            background: #c9302d;
                            position: absolute;
                            top: 0px;
                            left: 9px;
                            transform: rotate(45deg);
                        }

                        &:after {
                            content: "";
                            width: 5px;
                            height: 26px;
                            background: #c9302d;
                            position: absolute;
                            top: 0px;
                            left: 9px;
                            transform: rotate(-45deg);
                        }
                    }
                }
            }

            &.selected {

                .circle {
                    border-color: white;
                    display: flex;
                    justify-content: center;

                    .circle-small {
                        width: 27px;
                        height: 27px;
                        background: #0976bc;
                        border-radius: 50%;
                        align-self: center;
                    }
                }
            }
        }
    }
</style>



